// import { useEffect, useState } from 'react';
import { Amplify } from 'aws-amplify';

// project-imports
import Routes from 'routes';
import ThemeCustomization from 'themes';

// import Loader from 'components/Loader';
import Locales from 'components/Locales';
// import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
// import Customization from 'components/Customization';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';

// auth-provider
import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
import { TableContextProvider } from 'contexts/TableContext';

// aws configuration
import awsConfig from './aws-config';

// Initialize AWS Amplify
Amplify.configure(awsConfig);

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //
// import { dispatch } from 'store';
// import { fetchDashboard } from 'store/reducers/menu';

// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => {
  // const [loading, setLoading] = useState<boolean>(false);

  // useEffect(() => {
  //   dispatch(fetchDashboard()).then(() => {
  //     setLoading(true);
  //   });
  // }, []);

  // if (!loading) return <Loader />;

  return (
    <ThemeCustomization>
      {/* <RTLLayout> */}
      <Locales>
        <ScrollTop>
          <AuthProvider>
            <>
              <Notistack>
                <TableContextProvider>
                  <Routes />
                </TableContextProvider>
                <Snackbar />
              </Notistack>
            </>
          </AuthProvider>
        </ScrollTop>
      </Locales>
      {/* </RTLLayout> */}
    </ThemeCustomization>
  );
};

export default App;
